<template>
  <div id="hotels">
    <div id="content">
      <Header
        @update="update()"
        :page="'hotel_update'"
        :title_one="'hotels'"
        :action_one="''"
      ></Header>

      <div class="description" v-if="parseInt(event.type_id) != 17">
        {{ $t("hotels.rooming_info") }}
      </div>

      <template v-if="Object.values(rooming).length == 0"> </template>

      <template
        v-else-if="loaded"
        v-for="(rooming_key, rooming_index) in Object.keys(rooming)"
      >
        <div class="w50 info">
          <div class="title">{{ $t("titles.hotel") }}</div>
          <div
            class="row"
            v-if="Object.values(rooming)[rooming_index].hotel_id != undefined"
          >
            <div class="item">
              <div class="label">{{ $t("params.name") }}</div>
              <div
                class="value"
                v-if="
                  hotel[Object.values(rooming)[rooming_index].hotel_id].name !=
                    undefined
                "
              >
                {{ hotel[Object.values(rooming)[rooming_index].hotel_id].name }}
              </div>
            </div>
            <div class="item">
              <div class="label">{{ $t("params.address") }}</div>
              <div
                class="value"
                v-if="
                  hotel[Object.values(rooming)[rooming_index].hotel_id]
                    .address != undefined
                "
              >
                {{
                  hotel[Object.values(rooming)[rooming_index].hotel_id].address
                }}
              </div>
            </div>
            <div class="item">
              <div class="label">{{ $t("params.city") }}</div>
              <div
                class="value"
                v-if="
                  hotel[Object.values(rooming)[rooming_index].hotel_id].city !=
                    undefined
                "
              >
                {{ hotel[Object.values(rooming)[rooming_index].hotel_id].city }}
              </div>
            </div>
          </div>
          <div class="row" v-else style="height: ">
            {{ $t("undefined") }}
          </div>
        </div>

        <div class="w50">
          <div class="title">{{ $t("information") }}</div>
          <div class="row">
            <div class="item mid">
              <div class="label">
                {{ $t("hotels.first_hotel_service_long") }}
              </div>
              <div
                class="value"
                v-if="
                  hotel_services[
                    Object.values(rooming)[rooming_index].first_hotel_service_id
                  ] != undefined
                "
              >
                {{
                  $t(
                    hotel_services[
                      Object.values(rooming)[rooming_index]
                        .first_hotel_service_id
                    ].name
                  )
                }}
              </div>
              <div class="value" v-else>{{ $t("undefined") }}</div>
            </div>
            <div class="item mid">
              <div class="label">
                {{ $t("hotels.last_hotel_service_long") }}
              </div>
              <div
                class="value"
                v-if="
                  hotel_services[
                    Object.values(rooming)[rooming_index].last_hotel_service_id
                  ] != undefined
                "
              >
                {{
                  $t(
                    hotel_services[
                      Object.values(rooming)[rooming_index]
                        .last_hotel_service_id
                    ].name
                  )
                }}
              </div>
              <div class="value" v-else>{{ $t("undefined") }}</div>
            </div>
            <div class="item mid">
              <div class="label">{{ $t("hotels.entry_day") }}</div>
              <div class="value">
                {{
                  $t(Object.values(rooming)[rooming_index].start_date)
                    | showDate
                }}
              </div>
            </div>
            <div class="item mid">
              <div class="label">{{ $t("hotels.departure_day") }}</div>
              <div class="value">
                {{
                  $t(Object.values(rooming)[rooming_index].end_date) | showDate
                }}
              </div>
            </div>
            <div class="item mid">
              <div class="label">{{ $t("hotels.pax_rooming") }}</div>
              <div class="value">{{ team.n_housed }}</div>
            </div>
            <div class="item mid">
              <div class="label">{{ $t("titles.players") }}</div>
              <div class="value">{{ team.players_housed }}</div>
            </div>
            <div class="item mid">
              <div class="label">{{ $t("titles.staff") }}</div>
              <div class="value">{{ team.staff_housed }}</div>
            </div>
            <div class="item mid">
              <div class="label">{{ $t("titles.acompanyants") }}</div>
              <div class="value">{{ team.acompanyants_housed }}</div>
            </div>
            <!-- <div class="item">
              <div class="label">{{ $t("params.observations") }}</div>
              <div class="value">
                {{ $t(Object.values(rooming)[rooming_index].observations) }}
              </div>
            </div> -->
          </div>
        </div>

        <div class="rooms">
          <div class="title">{{ $t("hotels.rooms") }}</div>
          <div class="row">
            <div class="item w20">
              <div class="label">{{ $t("hotels.individual") }}</div>
              <div class="value">
                {{ Object.values(rooming)[rooming_index].num_rooms_1pax }}
              </div>
            </div>

            <div class="item w20">
              <div class="label">{{ $t("hotels.double") }}</div>
              <div class="value">
                {{ Object.values(rooming)[rooming_index].num_rooms_2pax }}
              </div>
            </div>

            <div class="item w20">
              <div class="label">{{ $t("hotels.triple") }}</div>
              <div class="value">
                {{ Object.values(rooming)[rooming_index].num_rooms_3pax }}
              </div>
            </div>

            <div class="item w20">
              <div class="label">{{ $t("hotels.quadruple") }}</div>
              <div class="value">
                {{ Object.values(rooming)[rooming_index].num_rooms_4pax }}
              </div>
            </div>

            <div class="item w20">
              <div class="label">{{ $t("hotels.quintuple") }}</div>
              <div class="value">
                {{ Object.values(rooming)[rooming_index].num_rooms_5pax }}
              </div>
            </div>
          </div>
        </div>

        <div class="rooming">
          <div class="title">{{ $t("hotels.rooming") }}</div>
          <div
            class="row"
            v-if="Object.values(rooming)[rooming_index].num_rooms_1pax > 0"
          >
            <div class="subtitle">{{ $t("hotels.individual") }}</div>
            <div
              class="item w22"
              v-if="rooming != undefined && item.num_pax == '1'"
              v-for="(item, index) in rooming[rooming_key].room"
            >
              <div class="type">
                {{ $t("hotels.room") }} {{ $t("hotels.individual") }}
              </div>
              <v-autocomplete
                v-for="(subitem, subindex) in item.relations"
                v-model="
                  rooming[rooming_key].room[index].relations[subindex].person_id
                "
                :items="Object.values(personsAvailable[rooming_key])"
                item-text="name"
                item-value="id"
                :item-disabled="item => item.available == false"
                clearable
                :browser-autocomplete="'asd2saS<'"
                @click:clear="clearPerson(rooming_key, index, subindex, $event)"
                @change="addPerson(rooming_key, index, subindex, $event)"
              >
                <template v-slot:item="data">
                  <span v-if="data.item.available == false">
                    <p v-text="data.item.name" style="color: #ccc"></p>
                  </span>
                  <span v-else>
                    <p v-text="data.item.name"></p>
                  </span>
                </template>
              </v-autocomplete>
            </div>
          </div>

          <div
            class="row"
            v-if="Object.values(rooming)[rooming_index].num_rooms_2pax > 0"
          >
            <div class="subtitle">{{ $t("hotels.double") }}</div>
            <div
              class="item w22"
              v-if="rooming != undefined && item.num_pax == '2'"
              v-for="(item, index) in rooming[rooming_key].room"
            >
              <div class="type">
                {{ $t("hotels.room") }} {{ $t("hotels.double") }}
              </div>
              <v-autocomplete
                v-for="(subitem, subindex) in item.relations"
                v-model="
                  rooming[rooming_key].room[index].relations[subindex].person_id
                "
                :items="Object.values(personsAvailable[rooming_key])"
                item-text="name"
                item-value="id"
                :item-disabled="item => item.available == false"
                clearable
                :browser-autocomplete="'asd2saS<'"
                @click:clear="clearPerson(rooming_key, index, subindex, $event)"
                @change="addPerson(rooming_key, index, subindex, $event)"
              >
                <template v-slot:item="data">
                  <span v-if="data.item.available == false">
                    <p v-text="data.item.name" style="color: #ccc"></p>
                  </span>
                  <span v-else>
                    <p v-text="data.item.name"></p>
                  </span>
                </template>
              </v-autocomplete>
            </div>
          </div>

          <div
            class="row"
            v-if="Object.values(rooming)[rooming_index].num_rooms_3pax > 0"
          >
            <div class="subtitle">{{ $t("hotels.triple") }}</div>
            <div
              class="item w22"
              v-if="rooming != undefined && item.num_pax == '3'"
              v-for="(item, index) in rooming[rooming_key].room"
            >
              <div class="type">
                {{ $t("hotels.room") }} {{ $t("hotels.triple") }}
              </div>
              <v-autocomplete
                v-for="(subitem, subindex) in item.relations"
                v-model="
                  rooming[rooming_key].room[index].relations[subindex].person_id
                "
                :items="Object.values(personsAvailable[rooming_key])"
                item-text="name"
                item-value="id"
                :item-disabled="item => item.available == false"
                clearable
                :browser-autocomplete="'asd2saS<'"
                @click:clear="clearPerson(rooming_key, index, subindex, $event)"
                @change="addPerson(rooming_key, index, subindex, $event)"
              >
                <template v-slot:item="data">
                  <span v-if="data.item.available == false">
                    <p v-text="data.item.name" style="color: #ccc"></p>
                  </span>
                  <span v-else>
                    <p v-text="data.item.name"></p>
                  </span>
                </template>
              </v-autocomplete>
            </div>
          </div>

          <div
            class="row"
            v-if="Object.values(rooming)[rooming_index].num_rooms_4pax > 0"
          >
            <div class="subtitle">{{ $t("hotels.quadruple") }}</div>
            <div
              class="item w22"
              v-if="rooming != undefined && item.num_pax == '4'"
              v-for="(item, index) in rooming[rooming_key].room"
            >
              <div class="type">
                {{ $t("hotels.room") }} {{ $t("hotels.quadruple") }}
              </div>
              <v-autocomplete
                v-for="(subitem, subindex) in item.relations"
                v-model="
                  rooming[rooming_key].room[index].relations[subindex].person_id
                "
                :items="Object.values(personsAvailable[rooming_key])"
                item-text="name"
                item-value="id"
                :item-disabled="item => item.available == false"
                clearable
                :browser-autocomplete="'asd2saS<'"
                @click:clear="clearPerson(rooming_key, index, subindex, $event)"
                @change="addPerson(rooming_key, index, subindex, $event)"
              >
                <template v-slot:item="data">
                  <span v-if="data.item.available == false">
                    <p v-text="data.item.name" style="color: #ccc"></p>
                  </span>
                  <span v-else>
                    <p v-text="data.item.name"></p>
                  </span>
                </template>
              </v-autocomplete>
            </div>
          </div>

          <div
            class="row"
            v-if="Object.values(rooming)[rooming_index].num_rooms_5pax > 0"
          >
            <div class="subtitle">{{ $t("hotels.quintuple") }}</div>
            <div
              class="item w22"
              v-if="rooming != undefined && item.num_pax == '5'"
              v-for="(item, index) in rooming[rooming_key].room"
            >
              <div class="type">
                {{ $t("hotels.room") }} {{ $t("hotels.quintuple") }}
              </div>
              <v-autocomplete
                v-for="(subitem, subindex) in item.relations"
                v-model="
                  rooming[rooming_key].room[index].relations[subindex].person_id
                "
                :items="Object.values(personsAvailable[rooming_key])"
                item-text="name"
                item-value="id"
                :item-disabled="item => item.available == false"
                clearable
                :browser-autocomplete="'asd2saS<'"
                @click:clear="clearPerson(rooming_key, index, subindex, $event)"
                @change="addPerson(rooming_key, index, subindex, $event)"
              >
                <template v-slot:item="data">
                  <span v-if="data.item.available == false">
                    <p v-text="data.item.name" style="color: #ccc"></p>
                  </span>
                  <span v-else>
                    <p v-text="data.item.name"></p>
                  </span>
                </template>
              </v-autocomplete>
            </div>
          </div>

          <v-tooltip
            v-model="addTooltip"
            top
            class="tooltip"
            transition="scroll-y-reverse-transition"
          >
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon color="grey lighten-1">mdi-cart</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("hotels.added_person") }}</span>
          </v-tooltip>

          <v-tooltip
            v-model="clearTooltip"
            top
            class="tooltip"
            transition="scroll-y-reverse-transition"
          >
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon color="grey lighten-1">mdi-cart</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("hotels.removed_person") }}</span>
          </v-tooltip>
        </div>
      </template>

      <SuccessPopup
        @close="closePopup()"
        @input="closePopup()"
        :dialog="success"
      ></SuccessPopup>
    </div>
  </div>
</template>
<script>
import i18n from "@/i18n";
import Header from "@/components/layout/Header";
import Equipment from "@/components/ui/Equipment.vue";
import SuccessPopup from "@/components/ui/SuccessPopup.vue";

export default {
  name: "hotels",
  components: {
    Header,
    Equipment,
    SuccessPopup
  },
  data() {
    return {
      rooming: false,
      success: false,
      personsAvailable: {},
      clearTooltip: false,
      addTooltip: false,
      loaded: false
    };
  },
  computed: {
    user() {
      return this.$store.getters["user/getUser"];
    },

    // rooming() {
    //   return this.$store.getters["hotel/getRooming"];
    // },

    hotel() {
      return this.$store.getters["hotel/getListKeyId"]();
    },

    hotel_services() {
      return this.$store.getters.getHotelServices();
    },

    team() {
      return this.$store.getters["team/getTeam"];
    },

    event () {
    return this.$store.getters['getCurrentEvent']()
    },

    persons() {
      if (this.team) {
        var result = {};

        for (var index in this.team.players) {
          if (this.team.players[index].modality == "1") {
            result[index] = { ...this.team.players[index] };
            result[index].name += " " + result[index].surname;
            result[index].available = true;
          }
        }

        for (var index in this.team.staff) {
          if (this.team.staff[index].modality == "1") {
            result[index] = { ...this.team.staff[index] };
            result[index].name += " " + result[index].surname;
            result[index].available = true;
          }
        }

        for (var index in this.team.acompanyants) {
          if (this.team.acompanyants[index].modality == "1") {
            result[index] = { ...this.team.acompanyants[index] };
            result[index].name += " " + result[index].surname;
            result[index].available = true;
          }
        }

        return result;
      } else return [];
    }
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.$overlay.show();
      var self = this;

      // scroll to top
      window.scroll(0, 0);

      if (this.user.admin) {
        this.$store.dispatch("club/loadClubEvent", {
          club_id: this.user.club_id,
          event_id: this.user.event_id
        });
      }

      this.$store
        .dispatch("hotel/loadRooming", {
          team_id: this.$route.params.team_id,
          event_id: this.user.event_id
        })
        .then(function(data) {
          //   var idx = self;
          self.$store
            .dispatch("hotel/loadList", { event: self.user.event_id })
            .then(function(response) {
              self.$store
                .dispatch("team/loadTeam", {
                  team_id: self.$route.params.team_id
                })
                .then(function(response) {
                  self.rooming = self.$store.getters["hotel/getRooming"];
                  self.updateAvailablePersons();
                  self.$overlay.hide();
                  self.loaded = true;
                });
            });
        });
    },

    // ROOMING METHODS
    clearPerson(rooming_key, room_id, relations_id, event) {
      this.clearTooltip = true;
      console.log(event);
      this.$store
        .dispatch("team/assignPersonToRoom", {
          team_id: this.$route.params.team_id,
          rel_room_person_id: relations_id,
          person_id: null
        })
        .then(function(response) {});
      this.rooming[rooming_key].room[room_id].relations[
        relations_id
      ].person_id = null;
      this.updateAvailablePersons();
      setTimeout(() => {
        this.clearTooltip = false;
      }, 1500);
    },

    addPerson(rooming_key, room_id, relations_id, person_id) {
      console.log(rooming_key);
      console.log(room_id);
      console.log(relations_id);
      console.log(person_id);

      if (person_id != undefined) {
        var self = this;
        this.$store
          .dispatch("team/assignPersonToRoom", {
            team_id: this.$route.params.team_id,
            rel_room_person_id: relations_id,
            person_id: person_id
          })
          .then(function(response) {
            self.rooming[rooming_key].room[room_id].relations[
              relations_id
            ].person_id = person_id;
            self.updateAvailablePersons();
            if (response) {
              self.addTooltip = true;
              setTimeout(() => {
                self.addTooltip = false;
              }, 1500);
            }
          });
      }
    },

    updateAvailablePersons() {
      // IF PERSONS IS EMPTY
      if (this.persons == []) {
        for (var rooming_index in this.rooming) {
          this.personsAvailable[rooming_index] = [];
        }
      }
      // ELSE PERSONS IS FILLED
      else {
        var result = {};
        var sortable = [];
        var persons = JSON.parse(JSON.stringify({ ...this.persons }));
        for (var rooming_index in this.rooming) {
          result[rooming_index] = persons;
          var usedPersons = [];
          var rooming = this.rooming[rooming_index];

          for (var room_index in rooming.room) {
            var room = rooming.room[room_index];

            for (var relations_index in room.relations) {
              var relations = room.relations[relations_index];
              if (
                relations.person_id != null ||
                relations.person_id != undefined
              ) {
                usedPersons.push(relations.person_id);
              }
            }

            // SET AVAIABLE FALSE
            usedPersons.forEach((element, index) => {
              console.log(element, index);
              console.log(JSON.parse(JSON.stringify(result[rooming_index])));
              if (result[rooming_index][element] != undefined) {
                result[rooming_index][element].available = false;
              }
            });

            // SORT
            sortable = { ...result };

            sortable[rooming_index] = Object.keys(result[rooming_index]).map(
              i => result[rooming_index][i]
            );

            sortable[rooming_index].sort(function(x, y) {
              return x.available === y.available ? 0 : x ? -1 : 1;
            });
          }
        }
        this.personsAvailable = sortable;
      }
    },

    update() {
      var validate = true;
      this.success = false;

      isEmpty(this.location_id)
        ? (this.error.location_id = true) && (validate = false)
        : (this.error.location_id = false);

      isEmpty(this.hotel.daterange_id)
        ? (this.error.daterange_id = true) && (validate = false)
        : (this.error.daterange_id = false);

      isEmpty(this.hotel.contact_name)
        ? (this.error.contact_name = true) && (validate = false)
        : (this.error.contact_name = false);

      isEmpty(this.hotel.contact_phone)
        ? (this.error.contact_phone = true) && (validate = false)
        : (this.error.contact_phone = false);

      if (validate) {
        var self = this;
        this.$store
          .dispatch("team/updatehotel", {
            team_id: this.user.team_id,
            data: JSON.stringify(this.hotel)
          })
          .then(function() {
            self.success = true;
          });
      }
    }
  },

  watch: {
    $route: "load"
  }
};
</script>
<style lang="scss" scoped>
/*GENERAL STYLES*/

.w50 {
  width: 50%;
  display: inline-table;
  padding: 12px;
}

.w20 {
  width: 20% !important;
  display: inline-block;
}

.w22 {
  width: 22% !important;
}

.bold {
  font-weight: bold;
}

/*PAGE SECTION STYLES*/
.mobile {
  display: none;
}

.description {
  margin-top: 25px;
}

#content {
  padding: 0 12px !important;
  padding-bottom: 50px !important;

  .info {
    margin: 20px auto;

    .card {
      background-color: #fafafa;
      padding: 10px;
      border-radius: 4px;
      overflow: hidden;
    }

    .hotel.card {
      .hotel.icon {
        height: 50px;
        width: 60px;
        float: left;
        margin: 0px 20px;
      }

      .hotel-info {
        //width: calc(100% - 100px);
        //float: right;

        &div {
          font-weight: bold;
        }
      }
    }
  }

  .row {
    background-color: #f5f5f5;
    border-radius: 3px;
    overflow: hidden;
    margin-bottom: 24px;
    padding: 6px 12px;
    height: auto;
    // min-height: 100px;
    margin-top: 10px;

    .item {
      display: inline-block;
      margin-bottom: 6px;
      width: 100%;

      &.mid {
        width: 50%;
      }
    }

    .label,
    .value {
      display: inline-block;
      font-size: 15px;
    }

    .label {
      width: 120px;
      text-align: right;
      margin-right: 12px;
      text-transform: uppercase;
      font-size: 12px;

      &:after {
        content: ":";
      }
    }
    .value {
      font-weight: bold;
    }
  }

  .rooms {
    .row {
      .item {
        margin-bottom: 0px;
      }
    }
  }

  .rooming {
    margin-top: 50px;

    .row {
      background-color: unset;
      padding: 6px 0;

      .subtitle {
        border-bottom: 1px solid #aaa;
        text-transform: uppercase;
      }

      .item {
        border: 1px solid #aaa;
        border-radius: 4px;
        padding: 10px;
        margin: 10px 2%;
        display: inline-block;

        &.w22:nth-child(4n + 2) {
          margin-left: 0;
        }

        &:nth-child(4n + 1) {
          margin-right: 0;
        }
      }
    }
  }
}

@include media("<=desktop") {
  #content {
    padding: 12px !important;

    .left,
    .right {
      width: 100%;
      display: block;
      padding: 0;
    }
  }
}

@include media(">phone", "<tablet") {
  #content {
    .row {
      .item {
        &.mid {
          width: 100%;
        }
      }
    }

    .w22 {
      width: 100% !important;
    }
  }
}

// TOOLTIP
.v-tooltip__content {
  background-color: #333;
  color: white !important;
  position: absolute;
  margin: 0 auto;
  left: 50% !important;
  opacity: 0.8 !important;
  index: 8;
  z-index: 8;
  bottom: 10% !important;
  top: unset !important;
  padding: 10px 20px;
  border-radius: 80px;
  -webkit-box-shadow: 1px 1px 5px -1px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 1px 1px 5px -1px rgba(0, 0, 0, 0.75);
  box-shadow: 1px 1px 5px -1px rgba(0, 0, 0, 0.75);

  span {
    color: white;
  }
}
</style>

<style lang="scss" scoped>
.mainButton {
  width: 150px !important;
  padding: 0;
  margin: 0;
  height: 100%;
  min-width: 40px;
  outline: none;
  cursor: pointer;
  font-size: 8pt;
  font-family: Speedee-Bold;
  border-radius: 3px;
  border: 1px solid #fc8926;
  text-transform: uppercase;
  background-color: transparent;
  color: #c55c00;
  height: 40px;
  padding: 0;
  font-family: Roboto-Bold;
  font-size: 14px;
  line-height: 14px;
  transition: background-color 0.5s ease;
  float: left;

  &:hover {
    background-color: #fc8a2623 !important;
  }
}

.section {
  float: left;
  display: block;
  width: 100%;
}

.search {
  float: right;
}

.dataTable {
  > div {
    table {
      text-align: center;
      width: 100%;
      margin: 20px auto 0;
      border-radius: 5px;

      overflow: visible;
      min-width: 600px;

      th {
        background-color: $secondary-color;
        background-color: #ddd;
      }
      td,
      th {
        border: 1px solid $secondary-color;
        padding: 12px !important;
        text-align: left;
        border-left: 0;
        border-right: 0;
        min-width: 60px;
      }

      tr:nth-child(even) {
        background-color: #f7f7f7;
      }

      th {
        font-weight: normal;
        border: 0 solid $secondary-color;
        color: $main-color;
        color: #333;
        padding: 20px;
        text-transform: uppercase;
      }
      th.column[role="columnheader"] {
        padding: 20px 12px 12px 12px !important;
      }

      th:nth-child(1) {
        width: 20%;
      }

      th:nth-child(2) {
        width: 20%;
      }

      th:nth-child(3) {
        width: 20%;
      }

      th:nth-child(4) {
        width: 20%;
      }

      th:nth-child(5) {
        width: 10%;
      }

      th:nth-child(6) {
        width: 10%;
      }

      tr:last-child {
        // border-bottom: 4px solid $main-color;
      }
    }
  }
}
</style>

<style lang="scss"></style>
